
// region JS Imports

// region External Modules
import $ from "jquery"
import param from "jquery-param"
import serialize from "form-serialize"
import URI from "urijs"
import { EventEmitter } from "events"
// endregion External Modules

// region Private Modules
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import {
  Factory as PriceDropdownFactory,
  SAPriceDropdown,
} from "./price_dropdown/index"
import {
  Factory as BedroomSelectPickerFactory,
  SABedroomSelectpicker,
} from "./bedroom_selectpicker/index"
import {
  Factory as AreaSizeDropdownFactory,
  BuyRentDesktopAreaSizeDropdown,
} from "./area_size_dropdown/index"
import {
  Factory as NeighbourhoodSelectFactory,
  NeighbourhoodSelectWithTerritoriesClass,
} from "./neighbourhood_select/index"
import {
  Factory as CurrencySelectorFactory,
  CurrencySelector,
} from "./currency_selector/index"
import {
  Factory as SortSelectFactory,
  SortSelect,
} from "./sort_select/index"
import {
  Factory as PropertyTypeSelectorFactory,
  PropertyTypeSelector,
} from "./property_type_selector/index"
// endregion Private Components

// endregion JS Imports


interface Selector {
  main: string
  form: string
  price_section_container: string

  reset_btn: string
}
interface InputSelector {
  main?: string
  form?: string
  price_section_container?: string

  reset_btn?: string
}
const DEFAULT_SELECTOR = {
  main: ".cell--serviced-apartments--searches--filter-bar--desktop-ver",
  form: "form",
  price_section_container: "#cell--serviced-apartments--searches--filter--price-container",

  reset_btn: ".cell--serviced-apartments--searches--filter-bar__btn-reset-criteria",
}


const FILTER_CHANGE = "with-state-filter-changed"


class DesktopFilter extends EventEmitter {
  protected selector: Selector
  protected $el: JQuery
  protected $reset_btn: JQuery
  protected $form: JQuery
  protected $price_section_container: JQuery

  protected neighbourhood_select?: NeighbourhoodSelectWithTerritoriesClass

  protected price_dropdown: SAPriceDropdown
  protected area_size_dropdown: BuyRentDesktopAreaSizeDropdown
  protected bedroom_selectpicker: SABedroomSelectpicker

  protected property_type_selector: PropertyTypeSelector

  protected currency_selector: CurrencySelector
  protected sort_select: SortSelect

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    this.$el = $(this.selector.main)

    this.$reset_btn = this.$el.find(this.selector.reset_btn)
    this.$form = this.$el.find(this.selector.form)
    this.$price_section_container = this.$el.find(this.selector.price_section_container)

    if ($(".cell-listing-filter__filter-option--neighbourhoods").length > 0){
      this.neighbourhood_select = NeighbourhoodSelectFactory.create()
    }
    this.price_dropdown = PriceDropdownFactory.create({scope: this.$el})
    this.area_size_dropdown = AreaSizeDropdownFactory.create({scope: this.$el})
    this.bedroom_selectpicker = BedroomSelectPickerFactory.create()

    this.currency_selector = CurrencySelectorFactory.create()
    this.property_type_selector = PropertyTypeSelectorFactory.create()
    this.sort_select = SortSelectFactory.create()

    this.created()
    this.bind_action()
  }

  public update(options?: {page?: number, refresh_price_container?: boolean}){
    const page = options?.page || 1
    const refresh_price_container = options?.refresh_price_container || false

    if (refresh_price_container){
      this.price_dropdown.reset()
    }

    const url = this.$form.attr("action")
    const form_data = serialize((this.$form[0] as HTMLFormElement), {hash: true}) || {}

    this.emit("DATA_ABOUT_TO_LOAD")

    const url_object = URI(url)
    url_object.query(param(Object.assign(form_data, {page: page})))

    this.$el.addClass("loading")

    q_ajax_3({
      type:     "GET",
      url:      url_object.toString(),
      dataType: "HTML",
    })
    .then(({data}) => {
      // # Append the HTML
      const $data_html = $("<div />").append(data)
      const result = $data_html.find("#serviced-apartment-building-list").html()
      if (refresh_price_container){
        const price_section_html = $data_html.find(DEFAULT_SELECTOR.price_section_container).html()
        this.$price_section_container.html(price_section_html)
        this.price_dropdown = PriceDropdownFactory.create({scope: this.$el})
        this.price_dropdown.on("val_change", () => {
          this.onValChange()
        })
      }

      this.emit("DATA_LOADED", result)
      this.$el.removeClass("loading")
    })
    .done()
  }

  protected created(){
    this.toggleFilterStatus()

    return this
  }
  protected bind_action(){
    if (this.neighbourhood_select != null) {
      this.neighbourhood_select.on("val_change", () => {
        this.onValChange()
      })
    }
    this.price_dropdown.on("val_change", () => {
      this.onValChange()
    })
    this.area_size_dropdown.on("val_change", () => {
      this.onValChange()
    })
    this.bedroom_selectpicker.on("val_change", () => {
      this.onValChange()
    })
    this.$reset_btn.on("click", () => {
      this.onResetClick()
    })
    this.sort_select.on("val_change", () => {
      this.onValChange()
    })
    this.currency_selector.on("val_change", () => {
      this.onValChange(true)
    })
    this.property_type_selector.on("val_change", () => {
      this.onValChange()
    })
  }
  protected toggleFilterStatus(){
    if (this.count() === 0){
      this.$el.removeClass(FILTER_CHANGE)
    }
    else{
      this.$el.addClass(FILTER_CHANGE)
    }
  }
  protected count(){
    let count = 0
    if (this.neighbourhood_select != null) {
      count += this.neighbourhood_select.isDefault() ? 0 : 1
    }
    count += this.price_dropdown.count()
    count += this.area_size_dropdown.count()
    count += this.bedroom_selectpicker.isDefault() ? 0 : 1
    count += this.currency_selector.isDefault() ? 0 : 1
    count += this.property_type_selector.isDefault() ? 0 : 1

    return count
  }
  protected reset(){
    if (this.neighbourhood_select != null) {
      this.neighbourhood_select.reset()
    }
    this.price_dropdown.reset()
    this.area_size_dropdown.reset()
    this.bedroom_selectpicker.reset()
    this.currency_selector.reset()
    this.property_type_selector.reset()
  }
  protected onValChange(refresh_price_container = false){
    this.toggleFilterStatus()
    this.update({refresh_price_container: refresh_price_container})
  }
  protected onResetClick(){
    this.reset()
    this.toggleFilterStatus()
    this.update()
  }
}


const Factory = {
  _instance: null as null | DesktopFilter,
  instance(selector?: InputSelector){
    if (this._instance != null) { return this._instance }

    this._instance = this.create(selector)
    return this._instance
  },
  create(selector?: InputSelector){
    return new DesktopFilter(selector)
  },
}

export {
  Factory,
}
